<template>
  <div>
    <div v-if="videoStatus">
      <video controls :src="video.src" class="w-100" id="video-upload" />
    </div>
    <div v-if="!videoStatus" class="upload-photo-icon d-flex mx-auto justify-content-center align-items-center" @click="$refs.fileInput.click()">
      <div>
        <i class="fas fa-cloud-upload-alt icon-size"></i>
        <div class="upload-text-size">{{ placeholder }}</div>
        <div v-if="sizeError" class="upload-error">ویدئو به صورت افقی باید بارگذاری شود</div>
      </div>
    </div>
    <UploadProgress :percent="percent" />
    <div v-if="videoStatus" class="d-flex justify-content-end align-items-center mt-3">
      <button @click="reset" class="reset-btn">{{ changeVideoBtnText }}</button>
      <Button @click.native="uploadVideo" :loading="loading" :text="uploadButtonLabel" v-if="hasUploadButton" btnClass="upload-btn btn-border" />
    </div>
    <input style="display: none" type="file" :accept="accept" @change="onFileSelected" ref="fileInput" />
  </div>
</template>

<script>
import 'vue-advanced-cropper/dist/style.css'
import Button from '../../../components/common/Button.vue'
import UploadProgress from '../UploadProgress.vue'
export default {
  components: {
    Button,
    UploadProgress,
  },
  props: {
    hasUploadButton: {
      default: true,
    },
    changeVideoBtnText: {
      default: 'تلاش مجدد',
    },
    loading: {
      type: Boolean,
      default: false,
    },
    accept: {
      type: String,
      default: 'video/*',
    },
    uploadButtonLabel: {
      type: String,
      default: 'آپلود ویدئو',
    },
    percent: {
      type: Number,
    },
    placeholder: {
      type: String,
      default: 'برای آپلود ویدئو کلیک کنید',
    },
  },
  data() {
    return {
      sizeError: false,
      selectedFile: '',
      videoStatus: false,
      video: {
        src: null,
      },
      videoUrl: null,
    }
  },
  watch: {
    'video.src'(c) {
      if (c) {
        setTimeout(() => {
          const video = document.getElementById('video-upload')
          if (video && video.clientHeight > video.clientWidth) {
            this.sizeError = true
            this.video.src = ''
            this.videoStatus = false
          }
        }, 100)
      }
    },
  },
  methods: {
    onFileSelected(event) {
      this.$emit('onFileSelected', event)
      this.videoStatus = true
      const blob = event.target.files[0]
      const formData = new FormData()
      formData.append('ListFiles', blob)
      this.videoUrl = formData
      this.video.src = URL.createObjectURL(blob)
    },
    uploadVideo() {
      this.$emit('videoSourceChanged', this.videoUrl)
      this.$emit('preload', this.video.src)
    },
    reset() {
      this.video.src = null
      this.videoStatus = false
      this.selectedFile = ''
      this.$emit('close')
    },
  },
}
</script>

<style scoped lang="scss">
.cropper {
  height: 400px;
  overflow: hidden;
  width: 600px;
}
::v-deep .vue-line-wrapper--north,
::v-deep .vue-line-wrapper--south,
::v-deep .vue-line-wrapper--east,
::v-deep .vue-line-wrapper--west {
  width: 0;
  height: 0;
}
.upload-photo-icon {
  height: 250px;
  width: 100%;
  border: 2px dashed #ced4da;
  border-radius: 8px;
}
.upload-text-size {
  font-size: 20px;
  text-align: center;
  margin-top: 10px;
  color: #495057;
}
.icon-size {
  font-size: 45px;
  text-align: center;
  display: block;
  color: #74788d;
}
.upload-btn {
  margin-right: 10px !important;
  background: #556ee6 !important;
  border-radius: 4px !important;
  color: white !important;
  padding: 8px 28px !important;
}
.reset-btn {
  display: block !important;
  background: white !important;
  border: 1px solid #556ee6 !important;
  border-radius: 4px !important;
  color: #556ee6 !important;
  padding: 8px 28px !important;
}

.upload-error {
  @extend .upload-text-size;
  color: #f46a6a;
  font-size: 18px;
}
</style>
